<template><slot /></template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeeCalculator',
  components: {},
  props: {
    countryCode: {
      type: String,
      default: 'BJ',
    },
    amount: {
      type: Number,
      default: 0,
    },
    src: {
      type: String,
      default: '',
    },
    dst: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      htmlValue: '',
      eventsIds: [],
      fees: {},
      bonuses: {},
      srcAmounts: {},
      srcAmount: 0,
    }
  },
  mounted() {},
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    scheduleFeeCalculation() {
      clearTimeout(this.timeoutId)
      this.makeLoading()
      this.timeoutId = setTimeout(() => {
        this.resetFees()
      }, 200)
    },

    field(propertyName) {
      return this.formFields.findIndex(el => el.propertyName == propertyName)
    },
    makeLoading() {
      if (!this.loadSavedFee()) {
        this.htmlValue = `<span class="text-green-300 text-sm font-bold"> Frais: Calcul en cours </span>`
      }
    },
    loadSavedFee() {
      let phoneCountry = this.countryCode

      const bonusNotEmpty = !this.$Commons.isEmpty(
        this.bonuses[`${phoneCountry}${this.src}${this.dst}${this.amount}`],
      )
      const feeNotEmpty = !this.$Commons.isEmpty(
        this.fees[`${phoneCountry}${this.src}${this.dst}${this.amount}`],
      )

      this.srcAmount =
        this.srcAmounts[`${phoneCountry}${this.src}${this.dst}${this.amount}`]

      const feeIsNull =
        !this.fees[`${phoneCountry}${this.src}${this.dst}${this.amount}`]

      if (bonusNotEmpty && feeIsNull) {
        this.htmlValue =
          `<span class="text-green-300 text-sm font-bold"> Bonus: ` +
          this.bonuses[`${phoneCountry}${this.src}${this.dst}${this.amount}`] +
          ' CFA </span>'
        this.feeAmount =
          this.bonuses[`${phoneCountry}${this.src}${this.dst}${this.amount}`]
        return true
      }

      if (feeNotEmpty) {
        this.htmlValue =
          `<span class="text-red-500 text-sm font-bold"> Frais: ` +
          this.fees[`${phoneCountry}${this.src}${this.dst}${this.amount}`] +
          ' CFA </span>'
        this.feeAmount =
          this.fees[`${phoneCountry}${this.src}${this.dst}${this.amount}`]
        return true
      }
    },
    async resetFees() {
      if (this.loadSavedFee()) return
      let phoneCountry = this.countryCode

      const { src, dst, amount } = this

      const serverFeeResponse = await this.$Events.sendDataRequestResolve(
        'calculateFees',
        {
          amount: amount,
          src: src,
          dst: dst,
          countryCode: phoneCountry,
        },
      )
      if (!serverFeeResponse.success) return
      this.fees[`${phoneCountry}${src}${dst}${amount}`] =
        serverFeeResponse.fee || 0
      this.bonuses[`${phoneCountry}${src}${dst}${amount}`] =
        serverFeeResponse.bonus || 0
      this.srcAmounts[`${phoneCountry}${src}${dst}${amount}`] =
        serverFeeResponse.srcAmount || 0

      this.loadSavedFee()
    },
  },
  watch: {
    amount: {
      immediate: true,
      handler() {
        this.scheduleFeeCalculation()
      },
    },
    src: {
      immediate: true,
      handler() {
        this.scheduleFeeCalculation()
      },
    },
    dst: {
      immediate: true,
      handler() {
        this.scheduleFeeCalculation()
      },
    },
    countryCode: {
      immediate: true,
      handler() {
        this.scheduleFeeCalculation()
      },
    },
    htmlValue: {
      immediate: true,
      handler() {
        this.$emit('feeCalculated', this.htmlValue, this.feeAmount)
      },
    },
    srcAmount: {
      immediate: true,
      handler() {
        this.$emit('srcAmountCalculated', this.srcAmount)
      },
    },
  },
})
</script>
